import VenderListComponent from '../../components/vendors-list/VenderListComponent'
import { useEffect, useState } from 'react'
import styles from './vendorsListPage.module.scss'
import { getVendors } from '../../features/vendorSlice'
import { useDispatch, useSelector } from 'react-redux'
import CommonModal from '../../components/atoms/modal/CommonModal'
import WeddingSelect from './Modals/WeddingSelect'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import { closeModal, setModalData } from '../../features/commonSlice'
import { toggleFavoriteVendor } from '../../features/kazooEventSlice'
import { Typography } from '@mui/material'
import { useTutorial } from '../../context/TutorialContext'
import { useTutorialStatus } from '../../hooks/useTutorialStatus'

export default function VendorsListPage({ type }) {
	const dispatch = useDispatch()
	const vendorFilters = useSelector((state) => state.vendor.vendorFilters)
	const modal = useSelector((state) => state.common.modal)
	const modalData = useSelector((state) => state.common.data)
	const [selectedKazoo, setSelectedKazoo] = useState(null)

	useEffect(() => {
		dispatch(getVendors({ ...vendorFilters, type, withRatings: true }))
	}, [dispatch, vendorFilters])

const tutorialId = type === 'vendor' ? 'vendors-list' : 
				   type === 'venue' ? 'venues-list' : ''

const { hasSeenTutorial, isLoading } = useTutorialStatus(tutorialId)
const { startTutorial, isTutorialActive } = useTutorial()

useEffect(() => {
	if (tutorialId && !isLoading && !hasSeenTutorial && !isTutorialActive()) {
		const timer = setTimeout(() => {
			startTutorial(tutorialId)
		}, 1000)

		return () => clearTimeout(timer)
	}
}, [
	tutorialId,
	isLoading,
	hasSeenTutorial,
	isTutorialActive,
	startTutorial,
	type,
])


	const closeAllModals = () => {
		dispatch(closeModal())
		setSelectedKazoo(null)
		dispatch(setModalData(null))
	}
	
	const handleSubmit = () => {
		if (selectedKazoo?._id && modalData?.vendorId) {
			dispatch(
				toggleFavoriteVendor({
					kazooId: selectedKazoo._id,
					vendorId: modalData.vendorId,
				})
			)
			closeAllModals()
		}
	}

	return (
		<>
			<div className={styles.pageWrap}>
				<div className={styles.pageHeader}>
					<Typography component="h1">
						{type[0].toUpperCase() + type.slice(1) + 's'}
					</Typography>
				</div>
				<VenderListComponent type={type} />
			</div>

			<CommonModal
				open={modal === 'addFavoriteVendorModal'}
				handleClose={closeAllModals}
				heading="Add to Favorites"
				subHeading="Select Wedding to add vendor in favorites"
				footerContent={
					<>
						<ButtonCustom
							onClick={closeAllModals}
							variant="outlined"
							size="lg"
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleSubmit}
						>
							Add
						</ButtonCustom>
					</>
				}
			>
				<WeddingSelect
					setSelectedKazoo={setSelectedKazoo}
					selectedKazoo={selectedKazoo}
					hideDetails={true}
				/>
			</CommonModal>
		</>
	)
}
